import { render, staticRenderFns } from "./pregunta-snp.vue?vue&type=template&id=692b2c27&scoped=true&"
import script from "./pregunta-snp.component.ts?vue&type=script&lang=ts&"
export * from "./pregunta-snp.component.ts?vue&type=script&lang=ts&"
import style0 from "./pregunta-snp.vue?vue&type=style&index=0&id=692b2c27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692b2c27",
  null
  
)

export default component.exports